import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function DocsSidebar({ sections, isOpen, onClose }) {
    const router = useRouter();
    const currentSlug = router.query.slug || '';

    return (
        <>
            <div
                className={`docs_sidebar_overlay ${isOpen ? 'visible' : ''}`}
                onClick={onClose}
            />
            <aside className={`docs_sidebar ${isOpen ? 'open' : ''}`}>
                <button className="docs_sidebar_close" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <div className="docs_sidebar_header">
                    <h2>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        HFDX Docs
                    </h2>
                </div>

                <nav className="docs_sidebar_nav">
                    {sections.map((section, index) => {
                        const isActive = section.slug === currentSlug;
                        const href = section.slug === '' ? '/docs' : `/docs/${section.slug}`;
                        const fullTitle = section.menuTitle || section.title;
                        const titleParts = fullTitle.split(/\s*[—–-]\s*/);
                        const mainTitle = titleParts[0];
                        const subtitle = titleParts.length > 1 ? titleParts.slice(1).join(' ') : null;

                        return (
                            <Link
                                key={index}
                                href={href}
                                className={`docs_sidebar_link ${isActive ? 'active' : ''}`}
                                onClick={onClose}
                            >
                                <span className="docs_sidebar_link_title">{mainTitle}</span>
                                {subtitle && <span className="docs_sidebar_link_subtitle">{subtitle}</span>}
                            </Link>
                        );
                    })}
                </nav>
            </aside>
        </>
    );
}
